import styled from 'styled-components'

import { Alignment, FontPreset } from '../styles/mixins'
import { Text } from './Text'

export const H3 = styled(Text)`
  ${FontPreset('h3')};
  ${Alignment({ verticalAlign: 'middle' })};
`
